'use strict';

var FBGsFilterByClassFactory = function FBGsFilterByClassFactory(DataFilter) {
  function FBGsFilterByClass() {
    DataFilter.call(this, 'fares-mode', 'fbcs-grid', 1);
  }
  FBGsFilterByClass.prototype = Object.create(DataFilter.prototype);
  FBGsFilterByClass.prototype.filter = function (data, range) {
    range = range[0];
    var classes = range.classes;
    return DataFilter.prototype.filter(data, classes, 'className');
  };
  return FBGsFilterByClass;
};
FBGsFilterByClassFactory.$inject = ['DataFilterFactory'];
module.exports = FBGsFilterByClassFactory;